import { Component, OnInit } from '@angular/core';
import { ControlDietaEntity, FiltrosControlDietaEntity, PacienteControlDietaGroup,
  FechaControlDietaGroup, JornadaControlDietaGroup } from '../../../../services/servicio-control-dieta.service';
import { ActivatedRoute } from '@angular/router';
import { EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';

@Component({
  selector: 'app-reporte-control-dieta',
  templateUrl: './reporte-control-dieta.component.html',
  styleUrls: ['./reporte-control-dieta.component.css']
})
export class ReporteControlDietaComponent implements OnInit {

  loading: boolean;
  preloading = true;
  mensajeError: string;
  fechaImpresion: Date;

  public filtros: FiltrosControlDietaEntity = {};

  entidad: EntidadEmpresarialEntity;
  data: ControlDietaEntity[] = [];
  pacientesData: PacienteControlDietaGroup[] = [];

  constructor( private activatedRoute: ActivatedRoute ) {
    this.activatedRoute.params.subscribe(params => {
      this.filtros.codigoBaseDatos = params['codigoBaseDatos'];
      this.filtros.uncoSede = params['uncoSede'];
    });
  }

  ngOnInit() {
  }

  // Listener

  updateLoading(value: boolean) {
    this.loading = value;
    this.mensajeError = null;
  }

  updateError(error: string) {
    this.loading = false;
    this.mensajeError = error;
  }

  updateData( response: {entidad: EntidadEmpresarialEntity, data: ControlDietaEntity[]}) {
    this.mensajeError = null;
    this.loading = false;
    this.fechaImpresion = new Date();
    this.entidad = response.entidad;
    this.data = response.data;
    this.pacientesData = this.getPacienteDataGroup(this.data);
  }

  // Auxiliar

  isPrepare() {
    return !this.loading && !this.mensajeError;
  }

  isPrepareData() {
    return this.isPrepare() && this.data && this.data.length > 0;
  }

  getPacienteDataGroup(data: ControlDietaEntity[]) {
    const pacientesGroup: PacienteControlDietaGroup[] = [];
    this.preloading = false;
    if (data && data.length > 0) {
      let pos = 0;
      data.forEach((d: ControlDietaEntity) => {
        const paciente = `${d.consecutivoAdmision} <br> ${d.nombrePaciente} <br> ${d.puntoAtencion}`;

        const pacienteIndex = pacientesGroup.findIndex((p: PacienteControlDietaGroup) => {
          return p.paciente === paciente;
        });

        if (pacienteIndex === -1) {
          const pac: PacienteControlDietaGroup = {
            paciente : paciente,
            fechas : [],
            data : [d],
            inicio : pos
          };
          pacientesGroup.push(pac);
        } else  {
          pacientesGroup[pacienteIndex].data.push(d);
        }
        pos++;
      });
    }

    if ( pacientesGroup && pacientesGroup.length > 0) {
      pacientesGroup.forEach((p: PacienteControlDietaGroup) => {
        p.fechas = this.getFechasDataGroup(p, p.inicio);
        p.rowsSpan = p.data.length;
        p.data = [];
      });
    }

    return pacientesGroup;
  }

  getFechasDataGroup(paciente: PacienteControlDietaGroup, pos: number): FechaControlDietaGroup[] {
    const fechasGroup: FechaControlDietaGroup[] = [];

    if (paciente.data && paciente.data.length > 0) {
      let pos2 = pos;
      paciente.data.forEach((d: ControlDietaEntity) => {
        const fecha = d.fechaDieta;

        const fechaIndex = fechasGroup.findIndex((f: FechaControlDietaGroup) => {
          return f.fecha === fecha;
        });

        if (fechaIndex === -1) {
          const fec: FechaControlDietaGroup = {
            fecha : fecha,
            jornadas : [],
            data : [d],
            inicio : pos2
          };
          fechasGroup.push(fec);
        } else {
          fechasGroup[fechaIndex].data.push(d);
        }
        pos2++;

      });
    }

    if ( fechasGroup && fechasGroup.length > 0) {
      fechasGroup.forEach((f: FechaControlDietaGroup) => {
        f.jornadas = this.getJornadaDataGroup(f, f.inicio);
        f.rowsSpan = f.data.length;
        f.data = [];
      });
    }

    return fechasGroup;
  }

  getJornadaDataGroup(fecha: FechaControlDietaGroup, pos: number): JornadaControlDietaGroup[] {
    const jornadasGroup: JornadaControlDietaGroup[] = [];

    if (fecha.data && fecha.data.length > 0) {
      let pos2 = pos;
      fecha.data.forEach((d: ControlDietaEntity) => {
        const jornada = d.descripcionJornadaDieta;
        const jornadaIndex = jornadasGroup.findIndex((j: JornadaControlDietaGroup) => {
          return j.jornada === jornada;
        });

        if (jornadaIndex === -1) {
          const jor: JornadaControlDietaGroup = {
            jornada : jornada,
            data : [d],
            inicio : pos2
          };
          jornadasGroup.push(jor);
        } else {
          jornadasGroup[jornadaIndex].data.push(d);
        }
        pos2++;
      });
    }
    return jornadasGroup;
  }

  // Auxiliares tabla
  isPaciente(i: number) {
    let find = false;
    for (let j = 0; j < this.pacientesData.length; j++) {
      const p = this.pacientesData[j];
      if (p.inicio === i) {
        find = true;
      }
    }
    return find;
  }

  getPaciente(i: number) {
    let find = '';
    for (let j = 0; j < this.pacientesData.length; j++) {
      const p = this.pacientesData[j];
      if (p.inicio === i) {
        find = p.paciente;
      }
    }
    return find;
  }

  getRowSpanPaciente(i: number) {
    let find = 0;
    for (let j = 0; j < this.pacientesData.length; j++) {
      const p = this.pacientesData[j];
      if (p.inicio === i) {
        find = p.rowsSpan;
      }
    }
    return find;
  }

  isFecha(i: number) {
    let find = false;
    for (let a = 0; a < this.pacientesData.length; a++) {
      const p = this.pacientesData[a];
      for (let b = 0; b < p.fechas.length; b++) {
        const f = p.fechas[b];
        if (f.inicio === i) {
          find = true;
        }
      }
    }
    return find;
  }

  getFecha(i: number) {
    let find = '';
    for (let a = 0; a < this.pacientesData.length; a++) {
      const p = this.pacientesData[a];
      for (let b = 0; b < p.fechas.length; b++) {
        const f = p.fechas[b];
        if (f.inicio === i) {
          find = f.fecha;
        }
      }
    }
    return find;
  }

  getRowSpanFecha(i: number) {
    let find = 0;
    for (let a = 0; a < this.pacientesData.length; a++) {
      const p = this.pacientesData[a];
      for (let b = 0; b < p.fechas.length; b++) {
        const f = p.fechas[b];
        if (f.inicio === i) {
          find = f.rowsSpan;
        }
      }
    }
    return find;
  }

  isJornada(i: number) {
    let find = false;
    for (let a = 0; a < this.pacientesData.length; a++) {
      const p = this.pacientesData[a];
      for (let b = 0; b < p.fechas.length; b++) {
        const f = p.fechas[b];
        for (let c = 0; c < f.jornadas.length; c++) {
          const j = f.jornadas[c];
          if (j.inicio === i) {
            find = true;
          }
        }
      }
    }
    return find;
  }

  getJornada(i: number) {
    let find = '';
    for (let a = 0; a < this.pacientesData.length; a++) {
      const p = this.pacientesData[a];
      for (let b = 0; b < p.fechas.length; b++) {
        const f = p.fechas[b];
        for (let c = 0; c < f.jornadas.length; c++) {
          const j = f.jornadas[c];
          if (j.inicio === i) {
            find = j.jornada;
          }
        }
      }
    }
    return find;
  }

  getRowSpanJornada(i: number) {
    let find = 0;
    for (let a = 0; a < this.pacientesData.length; a++) {
      const p = this.pacientesData[a];
      for (let b = 0; b < p.fechas.length; b++) {
        const f = p.fechas[b];
        for (let c = 0; c < f.jornadas.length; c++) {
          const j = f.jornadas[c];
          if (j.inicio === i) {
            find = j.data.length;
          }
        }
      }
    }
    return find;
  }

}
